export default __webpack_public_path__ + "static/media/fart.ae0015f9.mp3";